import { createContext, useState } from "react";

export const RpgModeContext = createContext();

export const RpgModeProvider = ({ children }) => {
  const [rpgMode, setRpgMode] = useState(true);

  const toggleRpgMode = () => setRpgMode((prev) => !prev);

  return (
    <RpgModeContext.Provider value={{ rpgMode, toggleRpgMode }}>
      {children}
    </RpgModeContext.Provider>
  );
};
